<template>
  <teleport to="head">
    <component :is="'script'" type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": {{ mainEntity }}
    }
    </component>
  </teleport>
</template>
<script>

export default {
  name: 'SchemaOrgFaqPage',
  props: {
    elements: {
      type: Array
    }
  },
  components: {
  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {
    mainEntity() {
      var array = new Array()
      for (var i = 0; i < this.elements.length; i++) {
        var el = this.elements[i]
        var obj = {
          "@type": "Question",
          "name": el.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": el.answer
          }
        }
        array.push(obj)
      }

      return array;
    }
  }
}
</script>
